module.exports = __webpack_public_path__ + "img/126.82a7b598.jpg";